import React, { useState, useEffect } from 'react';

import TagInput from 'Components/Forms/TagInput';
import VideoPreview from './VideoPreview';
import { extractVideoInfo } from './videoInfo';
import { t } from 'i18n';
import warningIcon from './icon_warning_circle.svg';

const i18nOpts = { scope: 'videos' };

const VideoModal = ({
  isNewRecord,
  url = '',
  name = '',
  description = '',
  allTags = [],
  tags: initialTags = [],
  apCount,
  onSubmit,
  onClose
}) => {
  const [videoUrl, setVideoUrl] = useState(url);
  const [videoName, setVideoName] = useState(name);
  const [videoDescription, setVideoDescription] = useState(description);
  const [currTags, setCurrTags] = useState(initialTags);
  const [suggestions, setSuggestions] = useState(allTags.filter(tag => !initialTags.includes(tag)));
  const [error, setError] = useState(false);

  const handleTagInputChange = (option) => {
    setCurrTags(option);
  };

  useEffect(() => {
    setSuggestions(allTags.filter(tag => !currTags.includes(tag)));
  }, [currTags, allTags]);
  
  const isValidEmbedLink = (link) => {
    const videoInfo = extractVideoInfo(link);
    return videoInfo !== null && videoInfo.id !== undefined;
  };
  
  const handleNameBlur = () => {
    if (!videoName.trim()) {
      setError((prev) => ({ ...prev, name: t('name_warn_message', i18nOpts) }));
    } else {
      setError((prev) => ({ ...prev, name: '' }));
    }
  };
  
  const handleLinkBlur = () => {
    if (!isValidEmbedLink(videoUrl)) {
      setError((prev) => ({ ...prev, videoUrl: t('embed_link_warn_message', i18nOpts) }));
    } else {
      setError((prev) => ({ ...prev, videoUrl: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isValidEmbedLink(videoUrl)) {
      return;
    }

    onSubmit({ videoUrl, videoName, videoDescription, currTags });
  };

  return (
    <>
      {apCount > 0 && <div className='message__warn'>
        <img src={warningIcon} className='icon__error' />
        {t('care_plan_count_warn_message', {
          ...i18nOpts,
          count: apCount,
        })}
      </div>}
      <form onSubmit={handleSubmit}>
        <div className='modal__field'>
          <label>{t('name', i18nOpts)}</label>
          <input
            type="text"
            value={videoName}
            onChange={(e) => setVideoName(e.target.value)}
            onBlur={handleNameBlur}
            required
          />
          {error.name && <p className='text__error'>{error.name}</p>}
        </div>
        
        <div className='modal__field'>
          <label>{t('video_input_link', i18nOpts)}</label>
          <input
            type="text"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            onBlur={handleLinkBlur}
            required
          />
          {error.videoUrl
            ? <div className="text__error">{error.videoUrl}</div>
            : <VideoPreview input={videoUrl} />}
        </div>

        <div className='modal__field'>
          <label>{t('description', i18nOpts) + ' (' + t('optional', i18nOpts) + ')'}</label>
          <input
            type="text"
            value={videoDescription}
            onChange={(e) => setVideoDescription(e.target.value)}
          />
        </div>

        <div className='modal__field'>
          <TagInput
            className="input"
            suggestions={suggestions}
            tags={currTags}
            handleTagInputChange={handleTagInputChange}
          />
        </div>

        <div className="modal__footer">
          <button
            type="button"
            className="btn--secondary"
            onClick={onClose}
          >
            {isNewRecord ? t('discard', i18nOpts) : t('cancel', i18nOpts)}
          </button>
          <button type="submit" className="button">
            {isNewRecord ? t('save', i18nOpts) : t('update', i18nOpts)}
          </button>
        </div>
      </form>
    </>
  );
};

export default VideoModal;
